export default __webpack_public_path__ + "static/media/Headers-otrosanos.ea308b7d.jpg";